import React, { Component } from 'react';
import T from 'i18n-react';
import logoAirRefund from '../assets/img/logo.png';
import cloud from '../assets/img/cloud.png';


export default class PaymentIntoduction extends Component {
  createMarkup(html) {
    return {__html: html};
  }
  setAdditionalLogo =()=> {
    const {
      organisation,
      affiliate,
    } = this.props.data;
    const { logoUrl, displayPaymentLogo } = organisation || '';
    const affiliateLogo = affiliate && affiliate.logoUrl;

    if(logoUrl && displayPaymentLogo){
      return logoUrl;
    }
    if(!affiliateLogo || !affiliateLogo.indexOf("AirRefund_Logo_HD") === -1){
      return;
    }
    return affiliateLogo;
  }
  render(){
    const {
      passengerTicket: { passengerFirstName, passengerLastName, passengerLanguage },
      airline,
      paxPercentageCommission,
      paxFlatCommission,
      paxCompensationAmount,
      paxToTransferAmount,
      totalArRevenue,
      charity,
      claim
    } = this.props.data;

    const paxCommision = (Number(paxFlatCommission > 0)) ? paxPercentageCommission + "% + " + Number(paxFlatCommission) + " EUR" : paxPercentageCommission + "%";
    const additionalLogo = this.setAdditionalLogo();

    return(
      <div>
        <header>
          <div className="logo-section">
            {additionalLogo &&(<img className="logo-scheneider" src={additionalLogo} alt="additional logo"/>)}
            <img className="logo-airrefund" src={logoAirRefund} alt="AirRefund logo"/>
            <img className="cloud" src={cloud} alt="Cloud"/>
          </div>
        </header>
        <section>
          <div className="success-info">
            <div className="container-internal">
              <h1 className="success-info__title">
                {T.translate("header")}
                <span className="bold"> {passengerFirstName}&nbsp;{passengerLastName}&nbsp;</span>
              </h1>
              <p className="success-info__text">
                {T.translate("paragraph", {
                  airline: airline,
                  id: claim.codeClaim,
                  totalCompensation: Number(paxCompensationAmount),
                  comission: paxCommision,
                  comissionAmount: Number(totalArRevenue),
                  paxCompensation: Number(paxToTransferAmount)
                })}
              </p>
              <div className="success-info__balance">
                {T.translate("balanceLine", {
                  paxCompensation:Number(paxToTransferAmount)
                })}
              </div>
              <span>{T.translate("giveIntoLine")}</span>
            </div>
          </div>
        </section>
        {charity && <section>
          <div className="donation">
            <div className="container-internal">
              <div className="donation__header">
                <h2 className="donation__header__title">
                  {T.translate("headerInformation")}
                </h2>
                {(charity.logoUrl)&&(<img className="donation__header__img" src={ charity.logoUrl } alt="Charity logo"/>)}
              </div>
              <div className="donation__text">
                <div dangerouslySetInnerHTML={this.createMarkup(charity.donation[passengerLanguage])} />
                </div>
            </div>
          </div>
        </section>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PaymentIntoduction.js